import {
  briefcaseOutline,
  businessOutline,
  cashOutline,
  codeOutline,
  fileTrayFullOutline,
  homeOutline,
  locationOutline,
  notificationsCircleOutline,
  pencilOutline,
  peopleOutline,
  pulseOutline,
  settingsOutline,
  shieldOutline,
  documentTextOutline,
  alarmOutline,
} from "ionicons/icons";
import { AppPage } from "../@types/appPage";
import { BusinessHome } from "../pages/BusinessHome";
import { DocumentCreate } from "../pages/DocumentCreate";
import { DocumentDetail } from "../pages/DocumentDetail";
import { DocumentList } from "../pages/DocumentList";
import { LocationCreate } from "../pages/LocationCreate";
import { LocationShow } from "../pages/LocationShow";
import { LocationsList } from "../pages/LocationsList";
import { MassiveDocumentCreate } from "../pages/MassiveDocumentCreate";
import { NotificationList } from "../pages/NotificationList";
import { OrganizationCreate } from "../pages/OrganizationCreate";
import { OrganizationList } from "../pages/OrganizationList";
import { OrganizationShow } from "../pages/OrganizationShow";
import { PaymentNoticeDetail } from "../pages/PaymentNoticeDetail";
import { PaymentNoticesList } from "../pages/PaymentNoticesList";
import { Profile } from "../pages/Profile";
import { ProfileDetail } from "../pages/ProfileDetail";
import { FichaMiDt } from "../pages/ProfileDetail/FichaMiDt";
import ProfilesListPage from "../pages/ProfileList";
import { RRHH } from "../pages/RRHH";
import { SettingsPage } from "../pages/SettingsPage";
import { SignerDocumentDetail } from "../pages/SignerDocumentDetail";
import { SignerDocumentList } from "../pages/SignerDocumentList";
import { SupervisorDocumentShow } from "../pages/SupervisorDocumentShow";
import { SupervisorHome } from "../pages/SupervisorHome";
import { SupervisorLocationShow } from "../pages/SupervisorLocationShow";
import { SupervisorUserDocumentUpload } from "../pages/SupervisorUserDocumentUpload";
import { SupervisorUserShow } from "../pages/SupervisorUserShow";
import { TemplateCreate } from "../pages/TemplateCreate";
import { TemplateDetail } from "../pages/TemplateDetail";
import { TemplateList } from "../pages/TemplateList";
import { UserAuthenticatedAccount } from "../pages/UserAuthenticatedAccount";
import { UserAuthUpdate } from "../pages/UserAuthUpdate";
import { UserCreate } from "../pages/UserCreate";
import { UserProfileLocation } from "../pages/UserProfileLocation";
import { UserShow } from "../pages/UserShow";
import { UsersList } from "../pages/UsersList";
import { UserUpdate } from "../pages/UserUpdate";
import { FileTemplateList } from "../pages/FileTemplateList";
import { FileTemplateCreate } from "../pages/FileTemplateCreate";
import { FileTemplateDetail } from "../pages/FileTemplateDetail";
import { FileTemplateUsers } from "../pages/FileTemplateUsers";
import { FileTemplateLocations } from "../pages/FileTemplateLocations";
import { SupervisorNewDocumentUpload } from "../pages/SupervisorUserShow/components/UploadNewDocument";
import { UserProfileOrganization } from "../pages/UserProfileOrganization";
import { Attendance } from "../pages/Attendance";
import { SupervisorDocuments } from "../pages/SupervisorDocuments";
import { HojaDeCargoInterior } from "../pages/SupervisorDocuments/components/HojaDeCargoInterior";
import { FileTypesList } from "../pages/FileTypesList";
import { FileTypeCreate } from "../pages/FileTypeCreate";
import { FileTypeDetail } from "../pages/FileTypeDetail";
import { UserTemplateAgreement } from "../pages/UserTemplateAgreement";
import { UserAssociateTemplate } from "../pages/UserAssociateTemplate";
import { UserTemplateDetail } from "../pages/UserTemplateDetail";
import { SignerDocumentsFromALink } from "../pages/SignerDocumentsFromALink";
import { MassNotification } from "../pages/MassNotification";
import { SpecificMassNotification } from "../pages/SpecificMassNotification";

export const appPages: AppPage[] = [
  {
    title: "Gerencia",
    url: "/app/gerencia",
    icon: businessOutline,
    component: BusinessHome,
    restricted: true,
    menu: true,
    exact: true,
  },
  {
    title: "Gerencia",
    url: "/app/gerencia/mis-clientes",
    icon: locationOutline,
    component: OrganizationList,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "Gerencia",
    url: "/app/gerencia/mis-clientes/nuevo",
    icon: locationOutline,
    component: OrganizationCreate,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "Gerencia",
    url: "/app/gerencia/mis-clientes/detalle/:id",
    icon: locationOutline,
    component: OrganizationShow,
    restricted: true,
    menu: false,
    exact: false,
  },

  {
    title: "Mi Cuenta",
    url: "/app/mi-cuenta/actualizar",
    component: UserAuthUpdate,
    icon: homeOutline,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh",
    icon: peopleOutline,
    component: RRHH,
    restricted: true,
    menu: true,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/acuerdos",
    component: DocumentList,
    icon: fileTrayFullOutline,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/acuerdos/:id",
    component: DocumentDetail,
    icon: fileTrayFullOutline,
    restricted: true,
    menu: false,
    exact: false,
  },
  {
    title: "SUPERVISION",
    url: "/app/supervision/colaborador/acuerdos/:from/:userId/:id",
    component: DocumentDetail,
    icon: fileTrayFullOutline,
    restricted: false,
    menu: false,
    exact: false,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/acuerdos/crear",
    component: DocumentCreate,
    icon: fileTrayFullOutline,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/acuerdos/creacion-masiva",
    component: MassiveDocumentCreate,
    icon: fileTrayFullOutline,
    restricted: true,
    menu: false,
    exact: true,
  },

  {
    title: "RRHH",
    url: "/app/rrhh/mi-dt",
    icon: briefcaseOutline,
    component: FichaMiDt,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/usuarios",
    icon: peopleOutline,
    component: UsersList,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/plantillas",
    icon: peopleOutline,
    component: TemplateList,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/plantillas-file",
    icon: peopleOutline,
    component: FileTemplateList,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/plantillas-file/crear",
    icon: peopleOutline,
    component: FileTemplateCreate,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/plantillas-file/detalle/:id",
    icon: peopleOutline,
    component: FileTemplateDetail,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/plantillas-file/asigna-usuarios/:id",
    icon: peopleOutline,
    component: FileTemplateUsers,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/plantillas-file/asigna-instalaciones/:id",
    icon: peopleOutline,
    component: FileTemplateLocations,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/plantillas/crear",
    icon: peopleOutline,
    component: TemplateCreate,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/plantillas/detalle/:id",
    icon: peopleOutline,
    component: TemplateDetail,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/tipos-de-archivos",
    icon: peopleOutline,
    component: FileTypesList,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/tipos-de-archivos/crear",
    icon: peopleOutline,
    component: FileTypeCreate,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/tipos-de-archivos/detalle/:id",
    icon: peopleOutline,
    component: FileTypeDetail,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/usuarios/:id",
    icon: peopleOutline,
    component: UserShow,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/usuarios/:id/editar",
    icon: peopleOutline,
    component: UserUpdate,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/usuarios/nuevo",
    icon: peopleOutline,
    component: UserCreate,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/usuarios/acuerdos/:id",
    icon: peopleOutline,
    component: UserTemplateAgreement,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/usuarios/acuerdos/:id/asociar/:template",
    icon: peopleOutline,
    component: UserAssociateTemplate,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/usuarios/crear-acuerdos/:id/:template",
    icon: peopleOutline,
    component: UserTemplateDetail,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/instalaciones",
    icon: locationOutline,
    component: LocationsList,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/instalaciones/nuevo",
    icon: locationOutline,
    component: LocationCreate,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/instalaciones/detalle/:id",
    icon: locationOutline,
    component: LocationShow,
    restricted: true,
    menu: false,
    exact: false,
  },
  {
    title: "Contabilidad",
    url: "/app/contabilidad",
    component: PaymentNoticesList,
    icon: cashOutline,
    restricted: true,
    menu: true,
    exact: true,
  },
  {
    title: "Contabilidad",
    url: "/app/contabilidad/abonos/detalle/:id",
    component: PaymentNoticeDetail,
    icon: cashOutline,
    restricted: true,
    menu: false,
    exact: false,
  },
  {
    title: "TIC",
    url: "/app/tic",
    icon: codeOutline,
    component: SettingsPage,
    restricted: true,
    menu: true,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/perfiles",
    icon: settingsOutline,
    component: ProfilesListPage,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/perfiles/crear",
    icon: shieldOutline,
    component: Profile,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "TIC",
    url: "/app/tic/perfiles/detalle/:id",
    icon: shieldOutline,
    component: ProfileDetail,
    restricted: true,
    menu: false,
    exact: false,
  },
  {
    title: "TIC",
    url: "/app/tic/perfiles/asigna-instalacion/:id",
    icon: businessOutline,
    component: UserProfileLocation,
    restricted: true,
    menu: false,
    exact: false,
  },
  {
    title: "TIC",
    url: "/app/tic/perfiles/asigna-cliente/:id",
    icon: businessOutline,
    component: UserProfileOrganization,
    restricted: true,
    menu: false,
    exact: false,
  },
  {
    title: "Notificaciones",
    url: "/app/notificaciones",
    icon: notificationsCircleOutline,
    component: NotificationList,
    restricted: false,
    menu: false,
    exact: true,
  },

  {
    title: "Hojas de cargo",
    url: "/app/documentos",
    component: SupervisorDocuments,
    icon: documentTextOutline,
    restricted: true,
    menu: true,
    exact: true,
  },

  {
    title: "Supervisión",
    url: "/app/supervision",
    icon: pulseOutline,
    component: SupervisorHome,
    restricted: true,
    menu: true,
    exact: true,
  },
  {
    title: "Supervisión",
    url: "/app/supervision/instalacion/:id",
    icon: pulseOutline,
    component: SupervisorLocationShow,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "Supervisión",
    url: "/app/supervision/colaborador/:id",
    icon: pulseOutline,
    component: SupervisorUserShow,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "Supervisión",
    url: "/app/supervision/acuerdos/:id",
    icon: pencilOutline,
    component: SupervisorDocumentShow,
    restricted: true,
    menu: false,
    exact: false,
  },
  {
    title: "Supervisión",
    url: "/app/supervision/colaborador/subir-documento/:id/:userId",
    icon: pencilOutline,
    component: SupervisorUserDocumentUpload,
    restricted: false,
    menu: false,
    exact: false,
  },
  {
    title: "Supervisión",
    url: "/app/supervision/colaborador/:from/:userId",
    icon: pencilOutline,
    component: SupervisorNewDocumentUpload,
    restricted: false,
    menu: false,
    exact: true,
  },
  {
    title: "Mis acuerdos",
    url: "/app/acuerdos/firma",
    icon: fileTrayFullOutline,
    component: SignerDocumentList,
    restricted: true,
    menu: true,
    exact: true,
  },
  {
    title: "Mis acuerdos",
    url: "/app/acuerdos/firma/:id",
    icon: pencilOutline,
    component: SignerDocumentDetail,
    restricted: true,
    menu: false,
    exact: false,
  },
  {
    title: "Asistencia cliente",
    url: "/app/asistencia",
    icon: alarmOutline,
    component: Attendance,
    restricted: true,
    menu: true,
    exact: true,
  },
  {
    title: "Mi Cuenta",
    url: "/app/mi-cuenta",
    component: UserAuthenticatedAccount,
    icon: homeOutline,
    restricted: true,
    menu: true,
    exact: true,
  },

  {
    title: "Supervisión",
    url: "/app/supervision/colaborador/subir-desde-plantilla/:userId",
    component: MassiveDocumentCreate,
    icon: fileTrayFullOutline,
    restricted: false,
    menu: false,
    exact: true,
  },
  {
    title: "Supervisión",
    url: "/app/supervision/colaborador/subir-firma-digital/:userId",
    component: DocumentCreate,
    icon: fileTrayFullOutline,
    restricted: false,
    menu: false,
    exact: true,
  },
  {
    title: "Hoja de Cargo",
    url: "/app/documentos/hoja-de-cargo/:id",
    component: HojaDeCargoInterior,
    icon: fileTrayFullOutline,
    restricted: false,
    menu: false,
    exact: true,
  },
  {
    title: "Documentos pendientes",
    url: "/app/acuerdos/pendientes/:channel",
    icon: fileTrayFullOutline,
    component: SignerDocumentsFromALink,
    restricted: false,
    menu: false,
    exact: true,
  },
  {
    title: "Documentos pendientes",
    url: "/app/acuerdos/pendientes/",
    icon: fileTrayFullOutline,
    component: SignerDocumentsFromALink,
    restricted: false,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/acuerdos/notificacion-masiva",
    component: MassNotification,
    icon: fileTrayFullOutline,
    restricted: true,
    menu: false,
    exact: true,
  },
  {
    title: "RRHH",
    url: "/app/rrhh/acuerdos/notificacion-especifica",
    component: SpecificMassNotification,
    icon: fileTrayFullOutline,
    restricted: true,
    menu: false,
    exact: true,
  },
];
